import { Path } from 'history'
import qs from 'qs'
import { getStore } from '../stores/stores-repository'
import { RoutingStore } from '../stores/routing-store'

export type QueryParams = {[key: string]: string}
export type QueryParamsChanger = (oldQueryParams: QueryParams) => QueryParams

export const goToRoute = (route: string, queryParamsChanger: QueryParamsChanger = () => ({}), messageToParent: boolean = true): void => {
    const queryParams = queryParamsChanger(getStore<RoutingStore>(RoutingStore.storeName).queryParams)

    const path: Path = route + '?' + qs.stringify(queryParams)

    getStore<RoutingStore>(RoutingStore.storeName).push(path)
}
